import { ArrowRight, CreditCard, Eye, FilePlus, FileText, Upload } from 'lucide-react';
import Panel from './Panel';

const ICONS = { review: Eye, payment: CreditCard, upload: Upload, invoices: FileText, create: FilePlus };

const NextStepsPanel = ({ steps, onNavigate }) => (
  <Panel title="What would you like to do next?" testId="next-steps" bodyClassName="">
    <ul className="divide-y divide-border">
      {steps.map(({ id, title, detail, cta, to }) => {
        const Icon = ICONS[id] || FileText;
        const urgent = id !== 'create';
        return (
          <li key={id} className="flex items-center gap-3 px-4 py-3" data-testid={`next-step-${id}`}>
            <Icon className={`w-4 h-4 shrink-0 ${urgent ? 'text-warning' : 'text-muted-foreground'}`} />
            <div className="min-w-0 flex-1">
              <span className="text-sm font-medium">{title}</span>
              <span className="text-xs text-muted-foreground"> &middot; {detail}</span>
            </div>
            <button
              type="button"
              onClick={() => onNavigate(to)}
              className="inline-flex shrink-0 items-center gap-1 text-sm underline underline-offset-2 hover:no-underline"
            >
              {cta} <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </li>
        );
      })}
    </ul>
  </Panel>
);

export default NextStepsPanel;
